import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CourseProvider } from './contexts/CourseContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Footer from './components/common/Footer';
import ScrollToTop from './components/common/ScrollToTop';

// Pages
import Home from './pages/Home';
//import About from './pages/About';
import ForgotPassword from './pages/ForgotPassword';

// Components
import Navbar from './components/common/Navbar';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ResetPassword from './components/auth/ResetPassword';
//import OtpVerification from './components/auth/OtpVerification';
import Profile from './components/user/Profile';
import EnrolledCourses from './components/user/EnrolledCourses';
import CourseDetail from './components/course/CourseDetail';
import CourseViewer from './components/course/CourseViewer';
import RefreshTokenTest from './components/test/RefreshTokenTest';
import MyLectures from './pages/MyLectures';
import UnitViewer from './components/unit/UnitViewer';
import GradeCoursesPage from './pages/GradeCoursesPage';
import ParentMonitoring from './pages/ParentMonitoring';



function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ThemeProvider>
          <AuthProvider>
            <CourseProvider>
              <ScrollToTop />
              <div className="min-h-screen bg-slate-50 flex flex-col">
                <Navbar />
                <main className="flex-grow">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/parent-monitoring" element={<ParentMonitoring />} />
                    

                                        
                    {/* Grade Courses Routes */}
                    <Route path="/courses/grade/:grade" element={<GradeCoursesPage />} />
                    
                    {/* Protected Routes */}
                    <Route path="/profile" element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    } />
                    <Route path="/enrolled-courses" element={
                      <ProtectedRoute>
                        <EnrolledCourses />
                      </ProtectedRoute>
                    } />
                    <Route path="/my-lectures" element={
                      <ProtectedRoute>
                        <MyLectures />
                      </ProtectedRoute>
                    } />
                    <Route path="/courses/:id" element={<CourseDetail />} />
                    <Route path="/course-player/:courseId" element={
                      <ProtectedRoute>
                        <CourseViewer />
                      </ProtectedRoute>
                    } />
                    <Route path="/unit-viewer/:id" element={
                      <ProtectedRoute>
                        <UnitViewer />
                      </ProtectedRoute>
                    } />
                    {/* Test Route */}
                    <Route path="/test-refresh-token" element={
                      <ProtectedRoute>
                        <RefreshTokenTest />
                      </ProtectedRoute>
                    } />
                  </Routes>
                </main>
                <Footer />
              </div>
            </CourseProvider>
          </AuthProvider>
        </ThemeProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
